module.exports = __webpack_public_path__ + "static/img/lwzp.82b7aa96.png";